import ReactGA from 'react-ga';

const hasPermission = () => typeof process.env.REACT_APP_GA_CODE !== 'undefined';

const initializeGoogleAnalytics = () => {
  if (hasPermission()) {
    ReactGA.initialize(process.env.REACT_APP_GA_CODE, {
      gaOptions: {
        anonymizeIp: true
      }
    });
  }
};

const trackPageView = (title) => {
  // console.log('trying to send', title);
  if (hasPermission()) {
    // console.log('sending', title);
    ReactGA.pageview(title);
  }
};

const trackCustomEvent = (event) => {
  if (hasPermission()) {
    ReactGA.event(event);
  }
};

export { initializeGoogleAnalytics, trackPageView, trackCustomEvent };
